import script from "./successfulPop.vue?vue&type=script&setup=true&name=successfulPop&lang=js"
export * from "./successfulPop.vue?vue&type=script&setup=true&name=successfulPop&lang=js"

import "./successfulPop.vue?vue&type=style&index=0&id=cda9fb4e&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cda9fb4e"]])

export default __exports__